<div class="template1 position-relative container px-0">
    <div class="search-container" *ngIf="!isMobile" appClickOutside (clickOutside)="closeSearchInput()">
        <div class="container px-0">
            <div class="row" *ngIf="isSearchHeaderShown">
                <div class="input-search-section" [ngClass]="{'input-search-section--active':isSearchHeaderShown,'input-search-section--inactive':!isSearchHeaderShown}">
                    <div class="search-box">
                        <div class="input-search-section--label" *ngIf="searchValue.length===0">
                            <label for="search" [class.has-error]="hasError && isSubmitted">{{'header.By Product Title, Item Number, Description'|translate|translateKey}}</label>
                        </div>
                        <div style="height: 10px;" class="float-right zindex-150" (click)="searchProducts()">
                            <a class="pointer">
                                <span class="input-search-icon"></span>
                            </a>
                        </div>
                    </div>
                    <input autofocus id="search-input" #searchBox name="search" class="input-search-field" aria-label="enter your search keyword. You can search by using Product Title, Item Number, Description." contenteditable="true" type="text" [(ngModel)]="searchValue" placeholder="" [class.has-error]="hasError && isSubmitted" (keyup)="focusOut($event)"
                        (keyup.enter)="fetchProducts()">
                    <ul *ngIf="originalSearchedString && originalSearchedString.length>=1" id="recent-search" class="list-unstyled mb-0 bt-0 px-1">
                        <li name="filter" [ngClass]="{active: i===activeIndex}" *ngFor="let item of originalSearchedString | filter : searchValue;let i=index;">
                            <div (keyup.enter)="searchValue=originalSearchedString[activeIndex];searchProducts()" (click)="searchValue=item;searchProducts()" class="row">
                                <span class="searchText txt-o col-9 col-sm-10 col-md-11 px-1" [innerHTML]="item | highlight : searchValue"></span>
                                <span class="float-right col-3 col-sm-2 col-md-1 text-right">
                  <span tabindex="0" class="pointer remove-text" (keyup.enter)="passIndex(i)" (click)="passIndex(i)">{{'header.Remove'|translate|translateKey}}</span>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="isMobile" class="product-search-mob">
        <ng-container *hasPrivilege="['SearchProducts']">
        <div class="input-search-section--active">
            <span class="input-search-icon pointer"></span>
            <input id="searchInput" [attr.aria-label]="'header.What are you looking for?' | translate | translateKey" (keyup)="onKeyUp($event)" type="text" [(ngModel)]="searchValue" placeholder="{{'header.What are you looking for?' | translate | translateKey}}" />
            <ul *ngIf="originalSearchedString && originalSearchedString.length>=1" class="list-unstyled product-search-mob__autocomplete">
                <li name="filter" [ngClass]="{active: i === activeIndex}" *ngFor="let item of originalSearchedString | filter : searchValue;let i=index;">
                    <div (click)="searchValue=item;searchProducts()">
                        <a class="searchText" tabindex="0" [innerHTML]="item | highlight : searchValue"></a>
                        <span class="float-right fa fa-trash-o" tabindex="0" (click)="passIndex(i)"></span>
                    </div>
                </li>
            </ul>
        </div>
        </ng-container>
    </div>
</div>